import styled from "styled-components";

import Background from "../../images/banner.png";
import BackgroundCard from "../../images/backgroundCard.png";

export const Container = styled.section`
  background-image: url(${Background});
  background-repeat: no-repeat;
  height: 665px;
  background-size: cover;
  display: flex;
  justify-content: center;
  padding: 0 20px;
  position: relative;
  border-bottom: 5px solid #1d364a;
`;

export const Content = styled.div`
  max-width: 1262px;
  width: 100%;
  display: flex;
  align-items: start;
  flex-direction: column;
  justify-content: center;
  gap: 100px;

  h1 {
    color: #f8f6f5;
    font-family: "Noto Serif";
    max-width: 740px;
    width: 100%;
    font-size: 50px;
  }

  @media (max-width: 425px) {
    h1 {
      font-size: 35px;
    }
  }
`;

export const Card = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 35px 20px 20px 60px;
  font-family: "Montserrat";
  gap: 20px;
  display: flex;
  flex-direction: column;
  background-image: url(${BackgroundCard});
  background-size: cover;
  margin-bottom: -250px;
  background-repeat: no-repeat;
  background-position: right;

  p {
    max-width: 619px;
    width: 100%;
    color: #1d364a;
    font-weight: 500;
  }

  button {
    background-color: #139ed5;
    color: white;
    font-size: 23px;
    border-radius: 5px;
    height: 60px;
    max-width: 313px;
    width: 100%;
    border: none;
    cursor: pointer;
    font-weight: 800;
    font-family: "Montserrat";
  }

  @media (max-width: 1060px) {
    background-image: none;
    padding: 20px;
    background-color: #e9eaec;

    p {
      font-size: 14px;
    }

    button {
      height: 40px;
      font-size: 13px;
    }
  }
`;
